import { render } from "./end_session.vue?vue&type=template&id=7821fd08"
import script from "./end_session.vue?vue&type=script&lang=js"
export * from "./end_session.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260814002725/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__